<template>
    <div id="updateProfileComponent">
        <div class="updateProfileComponent-inner">
            <div class="wz-row">
                <template v-if="parseInt(user_id)">
                    <form class="profile-update">
                        <div class="customer-info-general">
                            <!--<div class="thumbnail-customer">
                                <img src="../assets/images/default-user.png" alt="Avatar">
                            </div>-->
                            <div class="info-customer">
                                <form action="" class="form-associate" @submit.prevent="createUser" ref="customer">
                                    <div class="form-group justify-content-between">
                                        <h3>Your account information:</h3>
                                        <button class="btn btn-edit" @click.prevent="startEditing">{{!update? 'Edit' : 'Cancel'}}</button>
                                        <button class="btn btn-update" v-bind:class="{ loading: loading }" v-if="update" @click.prevent="startUpdate">Update</button>
                                    </div>
                                    <div class="form-group">
                                        <label for="givenName">Given Name:</label>
                                        <input type="text" class="form-control" id="givenName" v-model="member.givenName" :disabled="!update">
                                    </div>
                                    <div class="form-group">
                                        <label for="familyName">Family Name:</label>
                                        <input type="text" class="form-control" id="familyName" v-model="member.familyName" :disabled="!update">
                                    </div>
                                    <div class="form-group">
                                        <label for="mEmail">Email Address:</label>
                                        <input type="text" class="form-control" id="mEmail" v-model="member.email" :disabled="!update">
                                    </div>
                                    <div class="form-group">
                                        <label for="mPhone">Phone:</label>
                                        <input type="text" class="form-control" id="mPhone" v-model="member.phone" v-mask="'84##########'" :disabled="true">
                                    </div>

                                  <div class="form-group flex-column">
                                    <label>Usually you visit us:</label>
                                    <div class="form-check">
                                      <input class="form-check-input" type="radio" name="visit" id="visitWithChildren" value="1" v-model="member.visit"  :disabled="!update">
                                      <label class="form-check-label" for="visitWithChildren">With Children</label>
                                    </div>
                                    <div class="form-check">
                                      <input class="form-check-input" type="radio" name="visit" id="visitWithOutChildren" value="2" v-model="member.visit"  :disabled="!update">
                                      <label class="form-check-label" for="visitWithOutChildren">Without Children</label>
                                    </div>
                                    <div class="form-check">
                                      <input class="form-check-input" type="radio" name="visit" id="visitDontKnow" value="3" v-model="member.visit"  :disabled="!update">
                                      <label class="form-check-label" for="visitDontKnow">Don't Know</label>
                                    </div>
                                  </div>
                                  <p class="feature">Additional information - it&#39;s not mandatory, but by providing it, you will be eligible for
                                        additional freebies - like a birthday present! :)</p>
                                    <div class="form-group flex-column">
                                        <label>Are you:</label>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="gender" id="male" value="1" v-model="member.gender" :disabled="!update">
                                            <label class="form-check-label" for="male">Male</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="gender" id="female" value="0" v-model="member.gender" :disabled="!update">
                                            <label class="form-check-label" for="female">Female</label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                      <label :for="idDatePicker">Your date of Birth:</label>
                                      <datepicker :id="idDatePicker" v-model="member.birthday" :format="format"  :initialView="'year'" :disabled="!update"></datepicker>
                                    </div>

                                   <!-- <div class="form-group">
                                        <label>Your Nationality</label>
                                        <select v-model="customer.nationality">
                                            <option disabled value="null">Please select one</option>
                                            <option v-for="option in nationalities" v-bind:value="option">
                                                {{ option }}
                                            </option>
                                        </select>
                                    </div>-->
                                </form>
                            </div>
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import nationalities from '../nationalities.json';
    export default {
        name: 'UpdateProfile',
        data() {
            return {
                member: {},
                user_id: this.$foodbookConfig.user_phone,
                loading: false,
                nationalities:nationalities,
                idDatePicker:'mbirthday',
                format:'dd/MM/yyyy',
                update:false,
            };
        },
        computed: {
            fullName: {
                get: function () {
                    return this.member.familyName + ' , ' + this.member.givenName
                },
                set: function (newValue) {
                    var names = newValue.split(',',2);
                    this.member.givenName =  names[1]?names[1].trim():'';
                    this.member.familyName = names[0]?names[0].trim():'';
                }
            },
        },
        filters: {
            formatDate(date,type=true) {
                if(date){
                    if(type){
                        let d = new Date(date);
                        return ("0" + d.getDate()).slice(-2) + '/' + ("0" + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
                    }else{
                        let d = new Date(date.split('/').reverse().join('-'));
                        return d.toJSON();
                    }
                }
                return null;
            },
        },
        created() {
            if (parseInt(this.user_id)) {
                this.getMembership(this.user_id);
            }else{
                this.$toasted.show("The system has not been processed yet. Please try again later..", {
                    position: "top-center",
                    duration: 20000,
                    type: 'error'
                });
            }
        },
        methods: {
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            getTags: function() {
                let tags = this.member.tags || [];
                const visit = _.find(tags, function(o) { return o.startsWith('fVisit-') !== false; });

                if(visit === 'fVisit-WithChildren') {
                    this.member.visit = 1
                } else if (visit === 'fVisit-WithOutChildren') {
                    this.member.visit = 2
                } else if (visit === 'fVisit-DontKnow' || visit.length) {
                    this.member.visit = 3
                }
                return this.member.tags;
            },
            setTags: function(newVisit) {
                let tags = this.member.tags;
                let rs = _.filter(tags, function(o) { return o.startsWith('fVisit-') === false; });
                let tagVal,val;

                val = parseInt(newVisit);
                if( val === 1) {
                    tagVal = 'fVisit-WithChildren'
                } else if( val === 2) {
                    tagVal = 'fVisit-WithOutChildren'
                } else {
                    tagVal = 'fVisit-DontKnow';
                    val = 3
                }
                rs.push(tagVal);
                this.member.tags = rs;
                this.member.visit = val;
                return this.member.tags;
            },

            //Lay thông tin khách hàng
            getMembership($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: $phone
                    }
                }).then(response => {
                    if (response.data.error) {
                        this.$toasted.show("The system has not been processed yet. Please try again later..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                    } else {
                        if (response.body.data) {
                            let seft = this;
                            let _data = response.body.data;
                            this.member = Object.assign({}, {
                                birthday: response.body.data.birthday,
                                name: response.body.data.name,
                                phone: response.body.data.phone_number,
                                email: response.body.data.email,
                                gender: response.body.data.gender,
                                tags: response.body.data.tags || [],
                                visit: response.body.data.visit || 3,
                                givenName:null,
                                familyName:null
                            });
                            this.fullName = response.body.data.name;
                            this.getTags();
                        }
                    }
                }, response => {
                    // error callback
                    console.log("Error getMembership");
                });
            },
            startEditing(event){
                this.update = !this.update;
                if(!this.update){
                    this.loading = false;
                    this.getMembership(this.user_id);
                }
            },
            startUpdate(){
                if (!this.member.name) {
                    this.$toasted.show("You need to enter your given name!", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
               if (!this.member.familyName) {
                    this.$toasted.show("You need to enter your family name !", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.member.visit) {
                    this.$toasted.show("Do you normally visit the Snap Cafe / Thai Street as a family?", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.validEmail(this.member.email)) {
                    this.$toasted.show("Your email address is invalid", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.member.visit) {
                    this.$toasted.show("You need to enter Usually you visit us!", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                this.member.name = this.fullName;
                this.setTags(this.member.visit)
                this.member.birthday = this.$options.filters.formatDate(this.member.birthday);
                this.updateMembership();
            },
            updateMembership(){
                this.$http.post(this.$foodbookConfig.wpapi + '/updateMember', this.member, {method: 'POST'}).then(response => {
                    if (response.body.data === "1") {
                        this.$toasted.show("Update information successfully", {
                            position: "top-center",
                            duration: 5000,
                            type: 'success'
                        });
                        this.update = false;
                        this.loading = false;
                        this.member.birthday = this.$options.filters.formatDate(this.member.birthday,false);
                    } else {
                        this.update = false;
                        console.log(response.body.error);
                        this.$toasted.show("Update information failed, please try again later", {
                            position: "top-center",
                            duration: 10000,
                            type: 'error'
                        });
                    }
                }, response => {
                    console.log('Update information failed, please try again later');
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UpdateProfile.vue